import { FolderBreadcrumbs } from '@core/util/folder';
import { capitalizeFirstWord, stripHtml } from '@core/util/string';
import { Folder } from '@models/matter';
import { Selector } from '@ngxs/store';
import { UrlService } from '@services/url/url.service';
import { MergedMatterFolderSelectors } from '@state/global/documents/merged-folders';
import {
	SelectedDocument,
	SelectedMatterDocumentsState,
} from '@state/global/documents/selected-matter-documents.state';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { BreadcrumbItem } from 'src/app/shared/atomic/molecules/breadcrumb/breadcrumb.model';

export interface DocumentVM {
	documentTitle: string;
	documentsLoading: boolean;
	loading: boolean;
}

export class DocumentComponentSelector {
	@Selector([SelectedMatterDocumentsState.getViewingDocument])
	static isLoading(document: SelectedDocument): boolean {
		return !document?.exists;
	}

	@Selector([SelectedMatterDocumentsState.getLoading])
	static isDocumentLoading(loading: boolean): boolean {
		return !!loading;
	}

	@Selector([
		SelectedMatterDocumentsState.getViewingDocument,
		MergedMatterFolderSelectors.getAll,
		SelectedMatter.id,
	])
	static breadcrumbItems(
		doc: SelectedDocument,
		folders: Folder[],
		matterId: string,
	): BreadcrumbItem[] {
		const path: BreadcrumbItem[] = FolderBreadcrumbs(
			doc?.document?.folderId,
			folders,
		)
			.map((folderId) => folders.find((folder) => folder.id === folderId))
			.map((folder) => ({
				label: capitalizeFirstWord(stripHtml(folder.title)),
			}));

		return [
			{
				label: 'Documents',
				navigateTo: UrlService.Matter_Documents_SaleDocs(matterId),
			},
			...path,
			{
				label: doc?.document?.title,
			},
		];
	}
}
